import "./_login.scss";
import React from "react";
import SignUpDialog from "./sign-up-dialog";
import LoginDialog from "./login-dialog";
import ForgotPasswordDialog from "./forgot-password-dialog";
import superagent from "superagent";
import { connect } from "react-redux";
import { renderIf } from "../../../lib/util.js";
import PasswordReset from "./password-reset";
import isNil from "lodash/isNil";
import { merchantTypes, getLoginCopies } from "../../../lib/merchantUtils";
import { setLoading } from "../../../action/loading-actions";
import logoIcon from '../../../../asset/BaseMapLogo.png'

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      forgotPassword: false,
      backgroundTopographic: "hide",
      backgroundLanding: "show slideInLandingFromTop animation-delay-2",
      inOutBackground: true,
      showLoginSignUpButton: true,
      passwordReset: false,
    };
  }

  componentDidMount() {
    this.props.setLoading(false);
    let pathName = window.location.pathname;
    if (pathName === "/password-reset") {
      this.slideInOutBackground("passwordReset");
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.props.setLoading(false);
    // Typical usage (don't forget to compare props):
    // if (this.props.userID !== prevProps.userID) {
    // 	this.fetchData(this.props.userID)
    // }
    // console.log(this.state.email)
  }
  //TODO: Move to FB Componet
  fbAuthError = (text) => {
    let regex = /\/non-facebook\b/;
    if (regex.test(text)) {
      this.setState({
        emailError:
          "A user with this email already exists. Please login with password",
      });
    }
  };

  validEmail = (email) => {
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  showLogin = () => {
    this.setState({
      login: true,
      signup: false,
      forgotPassword: false,
      passwordReset: false,
    });
  };

  // handleBlur() {
  // 	if (!this.validEmail(this.state.email)) this.setState({ emailError: 'Please enter a valid email address' })
  // 	if (this.validEmail(this.state.email)) this.setState({ emailError: '' })
  // }

  handlePasswordReset = function (e) {
    e.preventDefault();

    if (this.state.email && this.validEmail(this.state.email)) {
      return new Promise((resolve, reject) => {
        let email = encodeURIComponent(this.state.email);
        superagent
          .get(`${__API_URI__}/password/get?userName=${email}`)
          .set("Content-Type", "application/json")
          .set("Platform", "Web")
          .set("Version", `${__version__}`)
          .end((err, res) => {
            if (err) {
              if (err.status == 401) {
                reject("error: ", err.status);
              }
              return reject("error: ", err.status);
            }
            resolve(res);
            this.setState({ email: "" });
            this.setState({ emailError: "" });
            this.showLogin();
          });
      });
    }
  };

  changeBackground() {
    this.setState({
      inOutBackground: !this.state.inOutBackground,
      //backgroundTopographic: this.state.inOutBackground ? 'show slideOutLandingFromTop' : 'hide',
      backgroundLanding: !this.state.inOutBackground
        ? "show slideInLandingFromTop"
        : "show slideOutLandingFromTop",
    });
  }

  slideInOutBackground(e) {
    switch (e) {
      case "showLogin":
        if (this.state.showLoginSignUpButton) {
          console.log('it is called if')
          this.setState({
            login: !this.state.login,
            signup: false,
            passwordReset: false,
            forgotPassword: false,
            showLoginSignUpButton: !this.state.showLoginSignUpButton,
          });
        } else {
          console.log('it is called else')
          this.setState({
            login: !this.state.login,
            signup: false,
            passwordReset: false,
            forgotPassword: false,
            showLoginSignUpButton: !this.state.showLoginSignUpButton,
          });
        }

        this.changeBackground();

        break;
      case "passwordReset":
        this.setState({
          login: false,
          signup: false,
          forgotPassword: false,
          passwordReset: true,
        });
        break;


      case "showLoginFromSignUp":
        this.setState({
          login: !this.state.login,
          signup: false,
          passwordReset: false,
          forgotPassword: false,
          showLoginSignUpButton: false,
        });
        break;

      case "showSignUpFromLogin":
        this.setState({
          login: false,
          signup: !this.state.signup,
          forgotPassword: false,
          passwordReset: false,
          showLoginSignUpButton: false,
        });
        break;

      case "showLoginDefault":
        if (this.state.showLoginSignUpButton) {
          this.setState({
            login: !this.state.login,
            signup: false,
            passwordReset: false,
            forgotPassword: false,
          });
        } else {
          this.setState({
            login: !this.state.login,
            signup: false,
            passwordReset: false,
            forgotPassword: false,
          });
        }
        break;

      case "showSignup":
        if (this.state.showLoginSignUpButton) {
          this.setState({
            login: false,
            signup: !this.state.signup,
            forgotPassword: false,
            passwordReset: false,
            showLoginSignUpButton: !this.state.showLoginSignUpButton,
          });
        } else {
          this.setState({
            login: false,
            signup: !this.state.signup,
            forgotPassword: false,
            passwordReset: false,
            showLoginSignUpButton: !this.state.showLoginSignUpButton,
          });
        }

        Countly.q.push([
          "add_event",
          {
            key: "Create Account",
            count: 1,
            segmentation: {
              "Action Type": "Viewed",
            },
          },
        ]);

        this.changeBackground();

        break;
      case "forgotPassword":
        this.setState({
          login: !this.state.login,
          signup: false,
          forgotPassword: !this.state.forgotPassword,
          passwordReset: false,
          showLoginSignUpButton: false,
        });
        break;

      default:
        console.log("process not expected...");
    }
  }

  getLoginButtons(style) {
    return (
      // <div style={{}}>
      //   <div>
      //     <h6 className="title-welcome">Welcome to</h6>
      //     {/* <h1 className="logo-header">Logo</h1> */}
      //     <h3 className="title-header">#1 In GPS App Technology</h3>
      //   </div>
      //   <div id="login-sign-up" className={style}>
      //     <button
      //       type="button"
      //       data-id="create account"
      //       onClick={(e) => this.slideInOutBackground("showSignup")}
      //     >
      //       Sign Up
      //     </button>
      //     <button
      //       type="button"
      //       data-id="login"
      //       onClick={(e) => this.slideInOutBackground("showLogin")}
      //     >
      //       Login
      //     </button>

      //   </div>
      // </div>
      <div style={{ width: '100%', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', }}>

        <div className="welcome-screen-container">

          <div className="welcome-screen-container-child" style={{ height: 45 }}> Welcome To</div>

          <div className="welcome-screen-container-child" style={{ height: 40 }}>
            <img src={logoIcon} style={{ width: '100%', height: 31 }}></img>
          </div>

          <div className="welcome-screen-container-child" style={{ height: 100 }}>
            <h3 className="in-gps-app-tech-style" style={{}}>#1 In GPS App Technology</h3>
          </div>

          <div className="welcome-screen-container-child" style={{ height: 130 }}>
            <div id="login-sign-up" className={{}} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', alignSelf: 'center', width: '100%', }}>
              <button
                type="button"
                data-id="create account"
                onClick={(e) => this.slideInOutBackground("showSignup")}
                style={{ backgroundColor: '#589500' }}
                className="button-style-home-page" xz
              >
                <p className="button-text-style">Sign Up</p>
              </button>
              <button
                type="button"
                className="button-style-home-page"
                data-id="login"
                onClick={(e) => this.slideInOutBackground("showLogin")}
                style={{ backgroundColor: '#333333' }}
              >
                <p className="button-text-style">Login</p>
              </button>
            </div>
          </div>
          <div className="welcome-screen-container-child" style={{ height: 100, alignItems: 'flex-end' }}>
            {/* <div style={{ display: 'flex' }}> */}
            <p style={{
              textAlign: 'center',
              font: 'normal normal normal 20px/26px Roboto',
              letterSpacing: '-0.6px',
              color: '#959595',
              opacity: 1,
              // marginBottom: '10px' // Add margin-bottom for space
            }}>
              Return to <a href="https://www.basemap.com/" target="_blank" rel="noopener noreferrer" className="custom-link" onClick={() => { console.log('clicked basemap') }}>
                www.basemap.com
              </a>
            </p>

            {/* </div> */}

          </div>

        </div>

        {/* <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '50%', width: '400px' }}>
          <div style={{ height: '50%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '50%', width: '400px' }}>


            <div style={{}}>
              <h6 className="welcome-to-style-h6" style={{}}>Welcome to</h6>
              <img src={logoIcon} style={{ width: '100%', height: 31 }}></img>
              <h3 className="in-gps-app-tech-style" style={{}}>#1 In GPS App Technology</h3>
            </div>

            <div id="login-sign-up" className={{}} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', alignSelf: 'center', width: '100%', height: '100vh', position: 'relative', top: 25 }}>
              <button
                type="button"
                data-id="create account"
                onClick={(e) => this.slideInOutBackground("showSignup")}
                style={{ backgroundColor: '#589500' }}
                className="button-style-home-page" xz
              >
                <p className="button-text-style">Sign Up</p>
              </button>
              <button
                type="button"
                className="button-style-home-page"
                data-id="login"
                onClick={(e) => this.slideInOutBackground("showLogin")}
                style={{ backgroundColor: '#333333' }}
              >
                <p className="button-text-style">Login</p>
              </button>
            </div>

            <div style={{ position: 'absolute', bottom: '20%', display: 'flex' }}>

              <p style={{
                textAlign: 'center',
                font: 'normal normal normal 20px/26px Roboto',
                letterSpacing: '-0.6px',
                color: '#959595',
                opacity: 1,
                marginBottom: '10px' // Add margin-bottom for space
              }}>
                Return to <a href="https://www.basemap.com/" target="_blank" rel="noopener noreferrer" className="custom-link" onClick={() => { console.log('clicked basemap') }}>
                  www.basemap.com
                </a>
              </p>

            </div>

          </div>
        </div> */}
      </div >
    );
  }

  getHeader(merchantType) {
    if (window.location.search.substring(1) === "eastmans") {
      return (
        <div className="login__redeem__header">
          <img
            src="../../../asset/Eastmans_wordmark.png"
            style={{ width: "100%", paddingBotton: "10px" }}
          />
          <p>
            {merchantType["loginWelcome"]}
            <br style={{ marginBotton: "10px" }} />
            {merchantType["loginHeader"]}
          </p>
          {/* <p>{merchantType.loginHeader}</p> */}
          <p>{merchantType.loginCopy}</p>
        </div>
      );
    }
    return (
      <div className="login__redeem__header">
        <p>{merchantType.loginHeader}</p>
        <p>{merchantType.loginCopy}</p>
      </div>
    );
  }

  getMerchantDialogue(isMerchant) {
    if (!isMerchant) {
      return null;
    }
    // const type = window.location.search.substring(1).split('=')[1],
    //   merchantType = merchantTypes[type]
    const merchantType = getLoginCopies();
    return (
      <div className="login__redeem">
        {this.getHeader(merchantType)}
        {this.getLoginButtons("login__options__promo")}
      </div>
    );
  }

  render() {
    const ep = window.location.pathname.substring(1),
      isMerchant = !isNil(merchantTypes[ep]);
    return (
      <div className="login">
        <div
        // className={
        //   "login__background__landing " + this.state.backgroundLanding
        // }
        />
        {renderIf(
          !this.state.login &&
          !this.state.signup &&
          !this.state.passwordReset &&
          isMerchant,
          this.getMerchantDialogue(isMerchant)
        )}
        {renderIf(
          // (device.type == 'mobile' && !this.state.signup) ||
          /\btype=\b/.test(window.location.href) &&
          !this.state.login &&
          !this.state.signup &&
          // !this.props.auth &&
          !this.state.passwordReset &&
          !isMerchant,
          <div className="login__redeem">
            <div className="login__redeem__header">
              <p>Ready to set up your Pro Membership?</p>
              <p>
                Create an Account or Login to upgrade and access all of the
                benefits of Pro Membership. After you upgrade you will be
                directed to the Mobile BaseMap App. Enjoy our robust Web App on
                your desktop or tablet at app.basemap.com.
              </p>
            </div>
            {this.getLoginButtons("login__options__promo")}
          </div>
        )}
        {renderIf(
          this.state.showLoginSignUpButton && !isMerchant,
          this.getLoginButtons("login__options")
        )}
        {renderIf(
          this.state.login,
          <LoginDialog
            userLoggedIn={(e) => this.props.userLoggedIn(e)}
            emailError={this.state.emailError}
            openTermsUpdate={() => this.props.openTermsUpdate()}
            slideInOutBackground={(e) => this.slideInOutBackground(e)}
          />
        )}
        {renderIf(
          this.state.forgotPassword,
          <ForgotPasswordDialog
            openTermsUpdate={() => this.props.openTermsUpdate()}
            slideInOutBackground={(e) => this.slideInOutBackground(e)}
            showLogin={this.showLogin}
          />
        )}
        {renderIf(
          this.state.signup,
          // <div className="login__signup">
          <SignUpDialog
            onBlur={() => this.handleBlur()}
            openTermsUpdate={() => this.props.openTermsUpdate()}
            slideInOutBackground={(e) => this.slideInOutBackground(e)}
            userLoggedIn={this.props.userLoggedIn}
          />
          // </div>
        )}

        {renderIf(
          this.state.passwordReset,
          <PasswordReset returnToLogin={() => this.showLogin()} />
        )}

        {/* <div className="login__logo fadeIn ">
          <img
            style={{ width: "20%" }}
            src="../../../asset/BaseMap_Primary_Corp_White_Logo_LARGE_Final-01.png"
          />
        </div> */}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  setLoading: (bool) => dispatch(setLoading(bool)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
